import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isDonation(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.DONATION && typeof label === 'string' && Array.isArray(value);
}
function _formatDonation(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatDonation(submission) {
  if (isDonation(submission)) {
    return _formatDonation(submission);
  }
  return undefined;
}
//# sourceMappingURL=donation-preview.js.map